import React from 'react';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 250,

    backgroundColor: theme.palette.background.paper,
    borderStyle: 'solid',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
  list: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 200,
  },
}));

const UserCard = ({ user, selectUser }) => {
  const classes = useStyles();

  const {
    name,
    email,
    lang,
    dob,
    salsaLevel,
    bachataLevel,
    classStats,
    phone,
    referredBy,
  } = user;

  return (
    <div className={classes.root}>
      <div className={classes.section1}>
        <Typography gutterBottom variant='h6'>
          {name}
        </Typography>
      </div>
      <Divider variant='middle' />
      <div className={classes.section2}>
        <List className={classes.list}>
          <ListItem>
            <ListItemText
              primary={`Classes Remaining: ${classStats.classesRemaining}`}
            />
          </ListItem>{' '}
          <ListItem>
            <ListItemText
              primary={`Classes Taken: ${classStats.classesTaken}`}
            />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Email: ${email}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Phone: ${phone}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`DOB: ${dob}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Lang: ${lang}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Salsa Level: ${salsaLevel}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Bachata Level: ${bachataLevel}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Referred By: ${referredBy}`} />
          </ListItem>
        </List>
      </div>
      <div className={classes.section3}>
        <Button onClick={() => selectUser(user)} color='primary'>
          Edit
        </Button>
      </div>
    </div>
  );
};

export default UserCard;
